import { DataNode } from "../../../interface/Trends";
import { capitalizeFirstLetterAndRemainingSmallForEachWord } from "../../../utils/commonUtils";

type Props = {
  data1?: DataNode | null;
  data2?: DataNode | null;
  data3?: DataNode | null;
};

const ColorAnalysisTable = ({ data1, data2, data3 }: Props) => {
  let tableData = data1;
  if (data3) tableData = data3;
  else if (data2) tableData = data2;

  if (!tableData) return null;
  return (
    <div className="min-w-full border border-gray-300 rounded-md font-poppins ">
      <div
        className={`grid  ${data2 && "grid-cols-5"} ${data3 && "grid-cols-6"} grid-cols-4  border-b border-gray-300 bg-gray-100 font-bold text-gray-800`}
      >
        <div className="p-2 border-r border-gray-300 text-center">Sr. No.</div>
        <div className="p-2 border-r border-gray-300 text-center">Color</div>

        <div className="p-2 border-r border-gray-300 text-center">
          {data3 ? "Color Combination" : "Hexcode"}
        </div>
        {data3 && (
          <div className="p-2 border-r border-gray-300 text-center">
            Hexcode
          </div>
        )}

        <div className="p-2 border-r border-gray-300 text-center">
          Percentage
        </div>
        {(data2 || data3) && (
          <div className="p-2 border-r border-gray-300 text-center ">
            Relative Percentage
          </div>
        )}
      </div>
      <div>
        {tableData.children?.map((row, index) => (
          <div
            key={index}
            className={`grid ${data2 && "grid-cols-5"} ${data3 && "grid-cols-6"} grid-cols-4  border-b border-gray-300 text-center`}
          >
            <div className="p-2 border-r border-gray-300 text-center">
              {index + 1}
            </div>
            <div className="p-2 border-r border-gray-300 text-center">
              {capitalizeFirstLetterAndRemainingSmallForEachWord(
                data3 ? data3.name : row.name
              )}
            </div>
            {data3 && (
              <div className="p-2 border-r border-gray-300 text-center">
                {row.name}
              </div>
            )}
            <div className="p-2 border-r border-gray-300 text-center">
              {row.color}
            </div>
            <div className="p-2 border-r border-gray-300 text-center ">
              {row.percentage.toFixed(2)}
            </div>
            {(data2 || data3) && (
              <div className="p-2 border-r border-gray-300 text-center ">
                {row.relativePercentage!.toFixed(2)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorAnalysisTable;
